import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

export const PreviewContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  grid-gap: 2.5rem;

  ${breakpoint('phoneUpperBoundary')`
      grid-template-rows: 1fr;
      grid-template-columns: 1fr 1fr;
    `};
`

export const NavigationButton = styled.button`
  border-radius: 50%;
  border: none;
  padding: 0.625rem;
  line-height: 0rem;
  position: absolute;
  top: 50%;

  &:hover {
    cursor: pointer;
    background: ${({ theme }) => theme.whiteColor};
  }
`

export const NavigationButtonContainer = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  width: 100%;
  padding: 1rem;
  box-sizing: border-box;
`
